module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'home-anim-active': _vm.isHomeAnimActive
    },
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('v-touch', {
    ref: "tapper",
    on: {
      "swiperight": _vm.prevGround,
      "swipeleft": _vm.nextGround
    }
  }, [_c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "container clearfix home-container"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('transition', {
    attrs: {
      "name": "headerText"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('h2', [_vm._v(_vm._s(_vm.$t('home.headingTopText')))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "firstText"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.headingSubText'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "secondText"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.headingBottomText'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mobile-height",
    class: {
      'anim-height': _vm.animFinished || !_vm.isHomeAnimActive
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "boxes"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('div', {
    staticClass: "boxes"
  }, [_c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "arrow arrow-prev",
    on: {
      "click": _vm.prevGround
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-next",
    on: {
      "click": _vm.nextGround
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "box-1"
    }
  }, [_c('router-link', {
    staticClass: "box farm-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'farm', next: _vm.mobileOption < 0, prev: _vm.mobileOption > 0
    },
    attrs: {
      "to": "/products/farms/presentation",
      "id": "farmGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.farmHover,
      "mouseleave": _vm.farmLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/wind-farm.svg"),
      "alt": "wind-farm"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.farms'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "box-2"
    }
  }, [_c('router-link', {
    staticClass: "box big airport-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'airport', next: _vm.mobileOption < 1, prev: _vm.mobileOption > 1
    },
    attrs: {
      "to": "/products/airport/presentation",
      "id": "airportGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.airportHover,
      "mouseleave": _vm.airportLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/airport.svg"),
      "alt": "airport"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.airports'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)\n                      ")])])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "box-3"
    }
  }, [_c('router-link', {
    staticClass: "box area-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'area', next: _vm.mobileOption < 2, prev: _vm.mobileOption > 2
    },
    attrs: {
      "to": "/products/area/presentation",
      "id": "forestGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.forestHover,
      "mouseleave": _vm.forestLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/area.svg"),
      "alt": "area"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.area'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scroll"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('a', {
    staticClass: "more-about-us",
    attrs: {
      "href": "#aboutUs",
      "data-scroll-offset": "60"
    },
    on: {
      "click": function (e) {
        _vm.smoothScroll(e);
        this$1.animFinished = true;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('moreAboutUs')))])]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('FooterOrange', {
    attrs: {
      "isAnim": _vm.isHomeAnimActive
    }
  })], 1), _vm._v(" "), _c('AboutUs', {
    attrs: {
      "isHome": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd60c89e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 315
// module chunks = 0